import { render, staticRenderFns } from "./QNA.vue?vue&type=template&id=3f6d6b02&"
import script from "./QNA.vue?vue&type=script&lang=js&"
export * from "./QNA.vue?vue&type=script&lang=js&"
import style0 from "./QNA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports